import { Button, Popconfirm } from "antd"
import { LockOutlined, UnlockOutlined } from "@ant-design/icons"
import { useState } from "react"
import { CloseEventModal } from "./CloseEventModal"
import { ClosePollModal } from "./ClosePollModal"
import { EventListStatus, getEventListStatus } from "./EventStatusTag"
import { EventService } from "../../Services/EventService"
import { TextService } from "../../Services/TextService"
import { EventState } from "../../Pages/Event/EventState"
import { EventType } from "../../Types/EventType"

/**
 * On Status & Svar: closes an open event, or opens one the admin closed again. A poll is closed by choosing its
 * final time. Nothing is shown when the deadline has passed or the event is finished, since opening it would not help.
 */
// Under the event link on Status & Svar.
const boxStyle = { textAlign: "left" as const, marginTop: 12 };

export const EventStateButton =(props: { event: any, onChanged: () => void }) => {
    const [showConfirm, setShowConfirm] = useState(false);
    const [showCloseModal, setShowCloseModal] = useState(false);
    const GetText = TextService.GetText;
    const event = props.event;
    const status = getEventListStatus({ state: event.eventState, deadline: event.eventDeadline, times: event.times });
    const isPoll = event.eventType === EventType.Poll;

    const onConfirmOpenEvent = async () => {
        await EventService.OpenEvent(event.eventId);
        setShowConfirm(false);
        props.onChanged();
    }

    const onClosed = () => {
        setShowCloseModal(false);
        props.onChanged();
    }

    if (!event.eventId) {
        return null;
    }

    if (status === EventListStatus.Open) {
        return <div style={boxStyle}>
            <Button icon={<LockOutlined />} onClick={() => setShowCloseModal(true)}>{GetText(isPoll ? "ReplyTable_ClosePollTitle" : "ReplyTable_CloseSignUp")}</Button>
            {isPoll ?
                <ClosePollModal event={event} open={showCloseModal} onCancel={() => setShowCloseModal(false)} onClosed={onClosed} /> :
                <CloseEventModal event={event} open={showCloseModal} onCancel={() => setShowCloseModal(false)} onClosed={onClosed} />}
        </div>;
    }

    if (status === EventListStatus.ClosedForReplies && event.eventState === EventState.Closed) {
        return <div style={boxStyle}><Popconfirm
            title={GetText("EventDetails_EventOpenQuestion")}
            open={showConfirm}
            onCancel={() => setShowConfirm(false)}
            placement="bottom"
            onConfirm={onConfirmOpenEvent}
        >
            <Button icon={<UnlockOutlined />} onClick={() => setShowConfirm(true)}>{GetText(isPoll ? "EventDetails_OpenPollAgain" : "EventDetails_OpenSignUpAgain")}</Button>
        </Popconfirm></div>;
    }

    return null;
}
